const INTRO_TITLE = "Heureux de vous retrouver";

export const LoginIntro = () => (
  <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white">
    {INTRO_TITLE}
  </h1>
);

LoginIntro.displayName = "LoginIntro";
